'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _resources = require('redux/modules/resources');

var _reactRouter = require('react-router');

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YES = 'Yes';
var NO = 'No';

var Module4App6 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module4,
    app: state.moduleData.data.module4.app6,
    profile: state.profile.data,
    module: state.resources.module,
    item: state.resources.item
  };
}, (0, _extends3.default)({}, moduleActions, { changeResource: _resources.changeResource, changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module4App6, _Component);

  function Module4App6() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module4App6);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module4App6.__proto__ || (0, _getPrototypeOf2.default)(Module4App6)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 4,
      appId: 6,
      module: 'Module 3',
      title: 'Consistency',
      isCompleted: _this.props.app.isCompleted || false,
      situationFind: _this.props.app.situationFind || '', // Is this a situation you sometimes find yourself in?
      toAddress: _this.props.app.toAddress || '' // Is this something you feel like you want to address?
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      // this.props.updateModule(this.props.user.userId, this.state.moduleId, {
      //   'numAppCompleted': numAppCompleted,
      //   'numAppTotal': this.props.allModule.numAppTotal});

      // this.props.changeItem(this.state.moduleId, 0, this.state.appId + 1);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleOnClick = function (module, modtype, item, event) {
      event.preventDefault();
      _this.props.changeItem(module, modtype, item);
    }, _this.handleResourceClick = function (module, item, event) {
      console.log(event);
      _this.props.changeResource(module, item, 0);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module4App6, [{
    key: 'getHimHer',


    /*
     * Returns him/her depending on child gender
     */
    value: function getHimHer() {
      if (this.props.profile.childGender === 'Male') {
        return 'him';
      }

      if (this.props.profile.childGender === 'Female') {
        return 'her';
      }

      return 'them';
    }

    /*
     * Handle when user finishes this module
     */


    /*
     * User types in something for what was
     * involved in the diet
     */


    // used to navigate to a resource item


    // used to navigate to a resource item

  }, {
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              this.state.module
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12, sm: 12, xs: 12 },
              _react2.default.createElement(
                'p',
                null,
                'It is ideal if your child\'s caregivers are all giving ',
                this.getHimHer(),
                ' ',
                _react2.default.createElement(
                  'strong',
                  { className: styles.orangeText },
                  'consistent messages'
                ),
                ' about food. However, this can be really difficult, as caregivers often have different views on what\'s best.'
              ),
              _react2.default.createElement(
                'h5',
                null,
                'Is this a situation you sometimes find yourself in?'
              ),
              _react2.default.createElement(
                ReactBootstrap.FormGroup,
                { onChange: this.handleChange.bind(this, 'situationFind') },
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'situationFind', value: YES, checked: this.state.situationFind === YES || this.state.situationFind == 1 },
                  YES
                ),
                _react2.default.createElement(
                  ReactBootstrap.Radio,
                  { name: 'situationFind', value: NO, checked: this.state.situationFind === NO || this.state.situationFind == 0 },
                  NO
                )
              ),
              (this.state.situationFind === NO || this.state.situationFind == 0) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'We have some tips on Getting support. You might find this helpful in the future if any issues do come up.'
                )
              ),
              (this.state.situationFind === YES || this.state.situationFind == 1) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'It can be a really difficult thing to address this with the other caregivers, and in some cases it\'s just not possible to get other caregivers on board'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'The important thing is that you are doing the best you can do, providing healthy foods and being a supportive role model for your child'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Don\'t try to change everything at once with the caregiver. Perhaps there is one rule or type of food that you could start with. Try to set aside enough time to discuss these issues with other caregivers so that all parties have a chance to share their opinions and concerns. Then try and develop a plan together that you can both agree on'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      'span',
                      null,
                      'Asking them to look through the program may also help to explain what you are doing, and why it is important for your child'
                    )
                  )
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  'Is this something you feel like you want to address?'
                ),
                _react2.default.createElement(
                  ReactBootstrap.FormGroup,
                  { onChange: this.handleChange.bind(this, 'toAddress') },
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'toAddress', value: YES, checked: this.state.toAddress === YES || this.state.toAddress == 1 },
                    YES
                  ),
                  (this.state.toAddress === YES || this.state.toAddress == 1) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      'We have some tips on Getting support.'
                    )
                  ),
                  _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'toAddress', value: NO, checked: this.state.toAddress === NO || this.state.toAddress == 0 },
                    'No/Don\'t know'
                  )
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: styles.spacer20 }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          ),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module4App6;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  profile: _propTypes2.default.object,
  module: _propTypes2.default.number,
  item: _propTypes2.default.number,
  changeResource: _propTypes2.default.func.isRequired,
  changeItem: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = Module4App6;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/4/App/App6.js
// module id = 1211
// module chunks = 0